import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Purpose } from 'src/app/shared/models/purpose.model';

@Injectable({
  providedIn: 'root'
})
export class PurposeListService {

  private url: string;
  private key: string;

  constructor(private http: HttpClient, public router: Router) {
      this.url = environment.apiUrl;
      this.key = environment.apiKey;
  }

  /**
   * 
   * @param filter 
   * @param offset 
   * @param limit 
   */
  public resolvePurposes(filter: string, offset: number, limit: number): Observable<object>
  {
    if (filter === '') {
      return this.getAllPurposes(offset, limit);
    } else {
      return this.getFilteredPurposes(filter, offset, limit);
    }
  }

  /**
   *
   */
  public getAllPurposes(offset: number, limit: number): Observable<object> {
    const headers = new HttpHeaders()
      .append('x-api-key', this.key);

    const params = new HttpParams()
      .append('offset', offset.toString())
      .append('limit' , limit.toString());

    return this.http
               .get(`${this.url}/purposes`, { responseType: 'json', headers, params })
               .pipe(
                 catchError(this.errorHandler)
               );
  }

  /**
   * 
   * @param filter 
   * @param offset 
   * @param limit 
   */
  private getFilteredPurposes(filter: string, offset: number, limit: number): Observable<object> {
    const headers = new HttpHeaders()
      .append('x-api-key', this.key);

    const params = new HttpParams()
      .append('filter', filter)
      .append('offset', offset.toString())
      .append('limit' , limit.toString());

    return this.http
               .get(`${this.url}/purposes/search`, { responseType: 'json', headers, params })
               .pipe(
                 catchError(this.errorHandler)
               );
  }

  /**
   *
   * @param purpose
   */
  create(purpose: Purpose) {
    const headers = new HttpHeaders()
      .append('x-api-key', this.key);

    return this.http
               .post(`${this.url}/purposes`, purpose, { responseType: 'json', headers })
               .pipe(
                catchError(this.errorHandler)
              );
  }

  /**
   *
   * @param stock
   */
  update(purpose: Purpose) {
    const headers = new HttpHeaders()
      .append('x-api-key', this.key);

    return this.http
               .put(`${this.url}/purposes`, purpose, { responseType: 'json', headers })
               .pipe(
                catchError(this.errorHandler)
              );
  }

  /**
   *
   * @param id
   */
  delete(id: number) {
    const headers = new HttpHeaders()
      .append('x-api-key', this.key);

    return this.http
               .delete(`${this.url}/purposes/${id}`, { responseType: 'json', headers })
               .pipe(
                catchError(this.errorHandler)
              );
  }

  /**
   *
   * @param error
   */
  private errorHandler(error: HttpErrorResponse) {
    console.log('Ha ocurrido un error al ejecutar el endpoint: ', error);
    return throwError(error);
  }
}
